module.exports = __webpack_public_path__ + "static/media/31.9471a1af.mp3";